import React, { PropTypes } from 'react';
import IconButton from 'material-ui/IconButton';
import { IconEdit, IconDelete, IconViewEye } from '../Icons';

import ConfirmMessage from '../ConfirmMessage';

class ListActionItems extends React.Component {
  static propTypes = {
    displayEdit: PropTypes.bool.isRequired,
    edit: PropTypes.func.isRequired,
    view: PropTypes.func,
    displayRemove: PropTypes.bool.isRequired,
    remove: PropTypes.func.isRequired,
    published: PropTypes.bool,
    record: PropTypes.object.isRequired,
    confirmMessageLabel: PropTypes.node
  };

  static defaultProps = {
    displayEdit: true,
    displayRemove: true,
    published: false,
    edit: () => {alert('edit')},
    remove: () => {alert('edit')}
  };

  static contextTypes = {
    muiTheme: PropTypes.object.isRequired
  };

  state = {
    open: false
  };

  confirm = () => {
    this.setState({ open: true });
  };

  close() {
    this.setState({ open: false });
  }

  render() {
    let { view, edit, remove, record, confirmMessageLabel,displayEdit, displayRemove, published } = this.props;
    let { baseTheme: { palette: { accent1Color, accent2Color }} } = this.context.muiTheme;

    return (
      <span>
        {view
          ? (
            <IconButton onClick={() => view(record.id)}><IconViewEye color={accent1Color} hoverColor={accent2Color}/></IconButton>)
          : null}
        
        {displayEdit
          ? ((published && !view)
              ? (<IconButton onClick={() => edit(record.id)}><IconViewEye color={accent1Color} hoverColor={accent2Color}/></IconButton>)
              : (<IconButton onClick={() => edit(record.id)}><IconEdit color={accent1Color} hoverColor={accent2Color}/></IconButton>)
            )
          : null}

        {displayRemove
          ? (
            <IconButton onClick={this.confirm}><IconDelete color={accent1Color} hoverColor={accent2Color}/></IconButton>)
          : null}
        <ConfirmMessage open={this.state.open}
                        label={confirmMessageLabel}
                        onConfirm={() => remove(record)}
                        onClose={() => this.close()}/>
      </span>
    );
  }
}

export default ListActionItems;





// WEBPACK FOOTER //
// ./src/components/List/ListActionItems.js